// extracted by mini-css-extract-plugin
export default {"header-box":"header_header-box__0Z3bb","header-nav":"header_header-nav__WdIN+"};